import { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import Dropdown from 'components/v2/Dropdown'
import List from 'components/v2/List'
import { DotsIcon } from 'components/Icons/DotsIcon'
import { drawerType } from 'types/drawer'
import { drawerToPrintVar } from 'variables/drawers'
import IconButton from 'components/v2/IconButton'

const DrawerActions = ({ drawer }: TSFixMe): TSFixMe => {
  const [isOpenDropdown, setOpenDropdown] = useState(false)

  const isDrawerClosed = !!drawer.endTime

  const toggleDropdown = (): TSFixMe => {
    setOpenDropdown(!isOpenDropdown)
  }

  return (
    <>
      <Dropdown.Wrapper noPadding noIndicator onClickAway={(): TSFixMe => setOpenDropdown(false)}>
        <IconButton icon={<DotsIcon />} onClick={toggleDropdown} noBorder smallPadding />
        <Dropdown.Content open={isOpenDropdown} noIndicator noOverflow left>
          <List.Container>
            <List.Item
              action
              onClick={(): TSFixMe => {
                if (isDrawerClosed) {
                  setOpenDropdown(false)
                  drawerToPrintVar(drawer)
                  setTimeout((): TSFixMe => {
                    window.print()
                  })
                }
              }}
              disabled={!isDrawerClosed}
            >
              <FormattedMessage id="drawers.list.actions.print" defaultMessage="Imprimir" />
            </List.Item>
          </List.Container>
        </Dropdown.Content>
      </Dropdown.Wrapper>
    </>
  )
}

DrawerActions.propTypes = {
  drawer: drawerType
}

export { DrawerActions }
